import React from 'react';
import { GridColumns } from '@material-ui/data-grid';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { JackpotTable } from '@screens/jackpot.winners/jackpot.winners.styles';

const columns: GridColumns = [
  { field: 'pid', headerName: 'Pid', width: 120 },
  { field: 'gameId', headerName: 'Game Id', width: 170 },
  { field: 'value', headerName: 'Value', width: 130 },
  { field: 'percentage', headerName: 'Percentage', width: 170 },
  { field: 'timestamp', headerName: 'Timestamp', ...formatColWithDate, width: 170 },
];

interface JackpotsData {
  pid: number;
}
let index = 0;
function createData(jackpotsData: JackpotsData) {
  index += 1;
  return { id: index, ...jackpotsData };
}

const JackpotWinnersRex = () => {
  const { authorizedServices } = useAuth();

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<JackpotsData[]>('/admin/jackpot/list', { params: { ...data, page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(null, runSearch, {
    placeholderData: noopArray,
  });

  const rows = responseData?.map(createData) || [];
  return (
    <JackpotTable>
      <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
    </JackpotTable>
  );
};

export default JackpotWinnersRex;
